/**
 * Shared timeout utility for wrapping promises with a deadline.
 *
 * Used by BaseAgent (LLM call timeouts) and DAGExecutor (node timeouts).
 */

/** Wrap a promise with a timeout. Rejects with a clear error if exceeded. */
export function withTimeout<T>(promise: Promise<T>, ms: number, label?: string): Promise<T> {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(
      () => reject(new Error(`${label ?? "Operation"} timed out after ${ms}ms`)),
      ms,
    );
    promise.then(
      (value) => {
        clearTimeout(timer);
        resolve(value);
      },
      (err) => {
        clearTimeout(timer);
        reject(err);
      },
    );
  });
}
